import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { cookiesPolicy } from '../cookiesPolicy';
import '../css/PoliPri.Module.css'
function PoliCookies() {
  const { i18n } = useTranslation();

  // Log para verificar a lista de políticas de cookies
  console.log('cookiesPolicy:', cookiesPolicy);

  return (
    <div className='container Cookies mt-5'>
      <div className='text'>
        {cookiesPolicy.map((item, index) => {
          // Log para verificar cada item e a linguagem atual
          console.log('item:', item);
          console.log('i18n.language:', i18n.language);

          // Verificar as chaves disponíveis em item.text
          console.log('Available languages in item.text:', item.text && Object.keys(item.text));

          // Verificar se item.text e item.text[i18n.language] existem
          const language = i18n.language;
          const text = item.text && item.text[language];
          console.log('text:', text);

          return (
            <div className="poli-cookies" key={index}>
              <Trans
                i18nKey={`cookiesPolicy_${index}`}
                components={{
                  1: <p />,
                  2: <h4 />,
                  3: <p />,
                  4: <em />,
                }}
              >
                {text ? text.replace(/&nbsp;/g, ' ') : `Texto não disponível para a linguagem ${language}`}
              </Trans>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PoliCookies;